/* jshint esversion: 6 */
jQuery(function ($) {
  // ### Internal Link Animation
  // Same Page
  $(document).on("click", "a[href^='#']", function (e) {
    e.preventDefault();
    var target = $(this).attr("href");

    if (target != "#" && $(target).length > 0 && !$(target).hasClass("chm-block-modal")) {
      var pos = $(target).offset().top - 100;

      $("html, body").stop().animate(
        {
          scrollTop: pos,
        },
        800
      );
    }
  });

  // New Page
  let hash = $(location).attr("hash");
  if (hash) {
    window.scrollTo(0, 0);

    let pos = $(hash).offset().top - 100;
    setTimeout(function () {
      $("html, body").stop().animate(
        {
          scrollTop: pos,
        },
        800
      );
    }, 400);
  }
    
  // ### Scroll Watch
  $(window).on("scroll", function () {
    var pos = $(document).scrollTop();
    if (pos > 0) {
      if (!$("body").hasClass("scrolled")) {
        $("body").addClass("scrolled");
      }
    } else {
      if ($("body").hasClass("scrolled")) {
        $("body").removeClass("scrolled");
      }
    }
  });

  // ### Toast
  const toast = function (text) {
    $("#toast").html(text);
    $("#toast").addClass("active");
    setTimeout(function () {
      $("#toast").removeClass("active");
    }, 5000);
  };

  // Default Modules
  Nav.init();
  Search.init();
  CookiesNotice.init();

  // Blocks
  if ($(".chm-block-accordion").length > 0) {
    Accordion.init();
  }

  if ($(".chm-block-bar-chart").length > 0) {
    BarChart.init();
  }

  if ($(".chm-block-cost-calculator").length > 0) {
    CostCalculator.init();
  }

  if ($(".chm-block-countup-box").length > 0) {
    CountUpBox.init();
  }

  if ($(".chm-block-journey").length > 0) {
    Journey.init();
  }

  if ($(".chm-block-mix-match-text").length > 0) {
    MixMatchText.init();
  }

  if ($(".chm-block-programs-tabs").length > 0) {
    ProgramsTabs.init();
  }

  if ($(".chm-block-query").length > 0) {
    Query.init();
  }

  if ($(".chm-block-query-prayer").length > 0) {
    QueryPrayer.init();
  }

  if ($(".chm-block-scenarios").length > 0) {
    Scenarios.init();
  }

  if ($(".chm-block-modal").length > 0) {
    Modal.init();
  }

  if ($("#exit-modal").length > 0) {
    ExitModal.init();
  }

  if ($(".chm-block-slider").length > 0) {
    Slider.init();
  }

  if ($(".chm-block-slider-prayer").length > 0) {
    SliderPrayer.init();
  }

  if ($(".chm-block-tabs").length > 0) {
    Tabs.init();
  }

  if ($("body").hasClass("page-template-template-block-library")) {
    BlockLibrary.init();
  }

  // Misc
  if ($(".read-progress").length > 0) {
    ReadProgress.init();
  }

  $(window).trigger("scroll"); // Keep this at the end

  // $(document).on('gform_confirmation_loaded', function(event, formId) {
  //   console.log(formId);

  //   $.getScript("//js.hsforms.net/forms/embed/v2.js", function() {
  //     hbspt.forms.create({
  //       region: "na1",
  //       portalId: "6634526",
  //       formId: "cb5b807c-4efe-4d7a-bb8b-f7747405517c"
  //     });

  //     console.log($(document).find('#hsForm_cb5b807c-4efe-4d7a-bb8b-f7747405517c').parent());
  //     $(document).find('#hsForm_cb5b807c-4efe-4d7a-bb8b-f7747405517c').parent().appendTo('#gform_confirmation_message_'+formId);

  //     console.log($('#hsForm_cb5b807c-4efe-4d7a-bb8b-f7747405517c').parent());
  //     form.appendTo('#gform_confirmation_message_'+formId);
  //   });
  // });

  // Set up selectors
    var _s = {
    gFormNextButton: ".gform_next_button",
      gFormSubmitButton: '.gform_button[type="submit"]',
      participationSelf: ".participation_self",
      over65Self: ".over_65_self",
      programSelf: ".program_self",
      pregnantSelf: ".pregnant_self",
      chmPlusSelf: ".chm_plus_self",
      participationSpouse: ".participation_spouse",
      over65Spouse: ".over_65_spouse",
      programSpouse: ".program_spouse",
      pregnantSpouse: ".pregnant_spouse",
    chmPlusSpouse: ".chm_plus_spouse",
    participationDependent: ".participation_dependent",
    programDependent: ".program_dependent",
    chmPlusDependent: ".chm_plus_dependent",
  };


  // pushing data events on each button click
  $(document).on("click", _s.gFormNextButton, function () {
    // Only proceed if we're on form 3
    const currentFormId = $(this).closest('form').attr('id').replace('gform_', '');
    if (currentFormId !== '3') return;

    const buttonText = $(this).val();

    // console.log("Button text:", buttonText);

    if (buttonText === "Next") {
      dataLayer.push({
        event: "tool_engagement",
        tool_name: "find_your_program",
        engagement_type: "next_click",
      });
      dataLayer.push(function () {
        this.reset();
      });
    }

  });

  $(document).on('gform_page_loaded', function (_event, form_id, _current_page) {
    // Find Your Program form submission event
    // pushing data events on form submission so they're only sent once, with final values
    
    if (form_id !== 3) return;
    
    // console.log("Form ID:", form_id);

      // Self selections
    $(_s.gFormSubmitButton).on('click', function () {
      const participationSelf = $("input[type='radio']:checked", _s.participationSelf).val();
      if (participationSelf === "Yes") {
        const person = "self";
        const age_over_65 = $("input[type='radio']:checked", _s.over65Self).val();
        const programSelf = $("input[type='radio']:checked", _s.programSelf).val();
        const program = programSelf.split('|')[0];
        const pregnant = $("input[type='radio']:checked", _s.pregnantSelf).val();
        const chmPlusSelf = $("input[type='radio']:checked", _s.chmPlusSelf).val();
        const chm_plus = chmPlusSelf.split('|')[0];
        dataLayer.push({
          event: 'tool_engagement',
          tool_name: "find_your_program",
          engagement_type: "self_selection",
          person,
          age_over_65,
          program,
          pregnant,
          chm_plus
        });
      }

      // Spouse selections
      const participationSpouse = $("input[type='radio']:checked", _s.participationSpouse).val();
      if (participationSpouse === "Yes") {
        const person = "spouse";
        const age_over_65 = $("input[type='radio']:checked", _s.over65Spouse).val();
        const programSpouse = $("input[type='radio']:checked", _s.programSpouse).val();
        const program = programSpouse.split('|')[0];
        const pregnant = $("input[type='radio']:checked", _s.pregnantSpouse).val();
        const chmPlusSpouse = $("input[type='radio']:checked", _s.chmPlusSpouse).val();
        const chm_plus = chmPlusSpouse.split('|')[0];
        dataLayer.push({
          event: 'tool_engagement',
          tool_name: "find_your_program",
          engagement_type: "spouse_selection",
          person,
          age_over_65,
          program,
          pregnant,
          chm_plus
        });
      }

      // Dependents selections
      const participationDependents = $("input[type='radio']:checked", _s.participationDependent).val();
      if (participationDependents === "Yes") {
        const person = "dependents";
        const programDependents = $("input[type='radio']:checked", _s.programDependent).val();
        const program = programDependents.split("|")[0];
        const chmPlusDependents = $("input[type='radio']:checked", _s.chmPlusDependent).val();
        const chm_plus = chmPlusDependents.split("|")[0];
        dataLayer.push({
          event: "tool_engagement",
          tool_name: "find_your_program",
          engagement_type: "dependents_selection",
          person,
          program,
          chm_plus,
          age_over_65: null,
          pregnant: null
        });
      }


      // Tool complete
      dataLayer.push({
        event: 'tool_complete',
        tool_name: "find_your_program",
        engagement_type: "tool_complete",
        person: null,
        age_over_65: null,
        program: null,
        pregnant: null,
        chm_plus: null
      });
    });
  });

});

jQuery(window).on("load", function ($) {
  // CHM CONTACT form submit scroll
  jQuery(".hs-form").on("submit", function () {
    jQuery([document.documentElement, document.body]).animate(
      {
        scrollTop: jQuery(".hbspt-form").offset().top - 250,
      },
      500
    );
  });
});
